module.exports = __webpack_public_path__ + "img/inspiration-6.ac96c65.jpg";